import React, { useState } from 'react';
import styled from 'styled-components';
import * as MyIcons from '../../../basic-ui-lib/icons';

const Icons = {
  IcChevronDown: MyIcons.IcChevronDown,
  IcChevronLeft: MyIcons.IcChevronLeft,
  IcChevronRight: MyIcons.IcChevronRight,
  IcArrowRight: MyIcons.IcArrowRight,
  IcArrowLeft: MyIcons.IcArrowLeft,
  IcChevronUp: MyIcons.IcChevronUp,
  IcPlus: MyIcons.IcPlus,
  IcMinus: MyIcons.IcMinus,
  IcTrash: MyIcons.IcTrash,
  IcColorFill: MyIcons.IcColorFill,
  IcClockIn: MyIcons.IcClockIn,
  IcPhone: MyIcons.IcPhone,
  IcSortBy: MyIcons.IcSortBy,
  IcPrint: MyIcons.IcPrint,
  IcWalkIn: MyIcons.IcWalkIn,
  IcCalendar: MyIcons.IcCalendar,
  IcAverage: MyIcons.IcAverage,
  IcQuickBooking: MyIcons.IcQuickBooking,
  IcSortCheckIn: MyIcons.IcSortCheckIn,
  IcClose: MyIcons.IcClose,
  IcCheck: MyIcons.IcCheck,
  IcTick: MyIcons.IcTick,
  IcArrange: MyIcons.IcArrange,
  IcDelete: MyIcons.IcDelete,
  IcIssue: MyIcons.IcIssue,
  IcOnline: MyIcons.IcOnline,
  IcInStore: MyIcons.IcInStore,
  IcCopy: MyIcons.IcCopy,
  IcBalance: MyIcons.IcBalance,
  IcDollar: MyIcons.IcDollar,
  IcRedeem: MyIcons.IcRedeem,
  IcList: MyIcons.IcList,
  IcGrid: MyIcons.IcGrid,
  IcMobile: MyIcons.IcMobile,
  IcImportantNote: MyIcons.IcImportantNote,
  IcCircleNumberTwo: MyIcons.IcCircleNumberTwo,
  IcInventory: MyIcons.IcInventory,
  IcCheckIn: MyIcons.IcCheckIn,
  IcBlockHour: MyIcons.IcBlockHour,
  IcBreak: MyIcons.IcBreak,
  IcNewCustomer: MyIcons.IcNewCustomer,
  IcRegularCustomer: MyIcons.IcRegularCustomer,
  IcNewAppt: MyIcons.IcNewAppt,
  IcAnyBody: MyIcons.IcAnyBody,
  IcPOS: MyIcons.IcPOS,
  IcCheckInFilled: MyIcons.IcCheckInFilled,
  IcSimpleMenu: MyIcons.IcSimpleMenu,
  IcSimpleMenu2: MyIcons.IcSimpleMenu2,
  IcReturn: MyIcons.IcReturn,
  IcNotReturn: MyIcons.IcNotReturn,
  IcNoteMulti: MyIcons.IcNoteMulti,
  IcReferal: MyIcons.IcReferal,
  IcTransaction: MyIcons.IcTransaction,
  IcCoupon: MyIcons.IcCoupon,
  IcClear: MyIcons.IcClear,
  IcHome1: MyIcons.IcHome1,
  IcReceipt: MyIcons.IcReceipt,
  IcTime: MyIcons.IcTime,
  IcClosedTicket: MyIcons.IcClosedTicket,
  IcReview: MyIcons.IcReview,
  IcDeduction: MyIcons.IcDeduction,
  IcMoney: MyIcons.IcMoney,
  IcNetSale: MyIcons.IcNetSale,
  IcQuickCommission: MyIcons.IcQuickCommission,
  IcStar: MyIcons.IcStar,
  IcInfor: MyIcons.IcInfor,
  IcSpecialize: MyIcons.IcSpecialize,
  IcUpload: MyIcons.IcUpload,
  IcImage: MyIcons.IcImage,
  IcSecurity: MyIcons.IcSecurity,
  IcPreview: MyIcons.IcPreview,
  IcWait: MyIcons.IcWait,
  IcHide: MyIcons.IcHide,
  IcShow: MyIcons.IcShow,
  IcEmail: MyIcons.IcEmail,
  IcFee: MyIcons.IcFee,
  IcPercent: MyIcons.IcPercent,
  IcEven: MyIcons.IcEven,
  IcManual: MyIcons.IcManual,
  IcPreOrder: MyIcons.IcPreOrder,
  IcLink: MyIcons.IcLink,
  IcRole: MyIcons.IcRole,
  IcQuickPay: MyIcons.IcQuickPay,
  IcWax: MyIcons.IcWax,
  IcMani: MyIcons.IcMani,
  IcGelX: MyIcons.IcGelX,
  IcDip: MyIcons.IcDip,
  IcGel: MyIcons.IcGel,
  IcPedi: MyIcons.IcPedi,
  IcAddOn: MyIcons.IcAddOn,
  IcOther: MyIcons.IcOther,
  IcGel2: MyIcons.IcGel2,
  IcHalfTurn: MyIcons.IcHalfTurn,
  IcSkip: MyIcons.IcSkip,
  IcFullTurn: MyIcons.IcFullTurn,
  IcEdit: MyIcons.IcEdit,
  Ic3Dots: MyIcons.Ic3Dots,
  IcVoidStamp: MyIcons.IcVoidStamp,
  IcRefundedPartial: MyIcons.IcRefundedPartial,
  IcFullRefunded: MyIcons.IcFullRefunded,
  IcAcrylic: MyIcons.IcAcrylic,
  IcCamera: MyIcons.IcCamera,
  IcCategory: MyIcons.IcCategory,
  IcTax: MyIcons.IcTax,
  IcSMS: MyIcons.IcSMS,
  IcMarketing: MyIcons.IcMarketing,
  IcExport: MyIcons.IcExport,
  IcGreaterThan: MyIcons.IcGreaterThan,
  IcPaymentMethod: MyIcons.IcPaymentMethod,
  IcEmpty: MyIcons.IcEmpty,
  IcMenuTicket: MyIcons.IcMenuTicket,
  IcMenuKeyIn: MyIcons.IcMenuKeyIn,
  IcMenuCustomer: MyIcons.IcMenuCustomer,
  IcMenuStaff: MyIcons.IcMenuStaff,
  IcMenuHome: MyIcons.IcMenuHome,
  IcMenuQuickView: MyIcons.IcMenuQuickView,
  IcMenuQRScan: MyIcons.IcMenuQRScan,
  IcMenuTurn: MyIcons.IcMenuTurn,
  IcMenuReport: MyIcons.IcMenuReport,
  IcMenuClockOut: MyIcons.IcMenuClockOut,
  IcMenuChange: MyIcons.IcMenuChange,
  IcMenuCashDrawer: MyIcons.IcMenuCashDrawer,
  IcMenuCalendar: MyIcons.IcMenuCalendar,
  IcMenuSetting: MyIcons.IcMenuSetting,
  IcMenuControlPanel: MyIcons.IcMenuControlPanel,
  IcMenuCashier: MyIcons.IcMenuCashier,
  IcMenuControlPanel2: MyIcons.IcMenuControlPanel2,
  IcFunctionService: MyIcons.IcFunctionService,
  IcFunctionGiftCardFill: MyIcons.IcFunctionGiftCardFill,
  IcFunctionAddPrice: MyIcons.IcFunctionAddPrice,
  IcFunctionVIP: MyIcons.IcFunctionVIP,
  IcFunctionProdut: MyIcons.IcFunctionProdut,
  IcPaymentTypeCash: MyIcons.IcPaymentTypeCash,
  IcPaymentTypeMultiPay: MyIcons.IcPaymentTypeMultiPay,
  IcPaymentTypeEpay: MyIcons.IcPaymentTypeEpay,
  IcPaymentTypeEpayActive: MyIcons.IcPaymentTypeEpayActive,
  IcPaymentTypeCreditCard: MyIcons.IcPaymentTypeCreditCard,
  IcPaymentTypeGiftCard: MyIcons.IcPaymentTypeGiftCard,
  IcPaymentTypeLoyaltyPoint: MyIcons.IcPaymentTypeLoyaltyPoint,
  IcPaymentTypeLoyaltyPointActive: MyIcons.IcPaymentTypeLoyaltyPointActive,
  IcPaymentTypeCashApp: MyIcons.IcPaymentTypeCashApp,
  IcPaymentTypeVenmo: MyIcons.IcPaymentTypeVenmo,
  IcPaymentTypePaypal: MyIcons.IcPaymentTypePaypal,
  IcPaymentTypeZelle: MyIcons.IcPaymentTypeZelle,
  IcPaymentTypeCheck: MyIcons.IcPaymentTypeCheck,
  IcCashierSplit: MyIcons.IcCashierSplit,
  IcCashierMerge: MyIcons.IcCashierMerge,
  IcCashierAccount: MyIcons.IcCashierAccount,
  IcCashierVoided: MyIcons.IcCashierVoided,
  IcCashierTip: MyIcons.IcCashierTip,
  IcCashierDiscount: MyIcons.IcCashierDiscount,
  IcCashierSave: MyIcons.IcCashierSave,
  IcCashierCalculator: MyIcons.IcCashierCalculator,
  IcCashierClear: MyIcons.IcCashierClear,
  IcCashierZoomOut: MyIcons.IcCashierZoomOut,
  IcCashierZoomIn: MyIcons.IcCashierZoomIn,
  IcCashierSearch: MyIcons.IcCashierSearch,
  IcCashierInfor: MyIcons.IcCashierInfor,
  IcGifScanQr: MyIcons.IcGifScanQr,
  IcService: MyIcons.IcService,
  IcAlert: MyIcons.IcAlert,
  IcSuccess: MyIcons.IcSuccess,
  IcMenu: MyIcons.IcMenu,
  IcNotification: MyIcons.IcNotification,
  IcAccount: MyIcons.IcAccount,
  IcMediaLibrary: MyIcons.IcMediaLibrary,
  IcScreen: MyIcons.IcScreen,
  IcChannel: MyIcons.IcChannel,
  IcPublish: MyIcons.IcPublish,
  IcDevice: MyIcons.IcDevice,
  IcDraft: MyIcons.IcDraft,
  IcMenuHide: MyIcons.IcMenuHide,
  IcSynchronize: MyIcons.IcSynchronize,
  IcPause: MyIcons.IcPause,
  IcReplace: MyIcons.IcReplace,
  IcAddress: MyIcons.IcAddress,
  IcFolder: MyIcons.IcFolder,
  IcPlay: MyIcons.IcPlay,
  IcCode: MyIcons.IcCode,
  IcFilter: MyIcons.IcFilter,
  IcPassword: MyIcons.IcPassword,
  IcIp: MyIcons.IcIp,
  IcResolution: MyIcons.IcResolution,
  IcOperatingSystem: MyIcons.IcOperatingSystem,
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const IconGrid = styled.div<{ cols?: number }>`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols ?? 8}, 1fr)`};
  gap: 1rem;
  padding: 1rem;
`;

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  }
`;

const IconName = styled.span`
  font-size: 0.875rem;
  color: #4a5568;
`;

const Tooltip = styled.div<{ $visible: boolean }>`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #000;
  color: #fff;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  white-space: nowrap;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  transition: opacity 0.2s;
  pointer-events: none;
`;

const ToggleButton = styled.button`
  margin: 1rem 0;
  padding: 0.5rem 1rem;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  cursor: pointer;

  &:hover {
    background-color: #edf2f7;
  }
`;

type IconSectionProps = {
  title: string;
  iconSet: Record<string, React.ComponentType<any>>;
  showNames: boolean;
  onCopy: (name: string) => void;
  hoveredIcon: string | null;
  setHoveredIcon: (name: string | null) => void;
  copiedIcon: string | null;
};

const IconSection = ({
  title,
  iconSet,
  showNames,
  onCopy,
  hoveredIcon,
  setHoveredIcon,
  copiedIcon,
}: IconSectionProps) => (
  <>
    <h1>{title}</h1>
    <IconGrid cols={showNames ? 8 : 20}>
      {Object.entries(iconSet).map(([name, Icon]) => (
        <button key={name} onMouseEnter={() => setHoveredIcon(name)} onMouseLeave={() => setHoveredIcon(null)}>
          <IconWrapper onClick={() => onCopy(name)}>
            {/* @ts-ignore */}
            <Icon width={24} height={24} />
            <Tooltip $visible={(hoveredIcon === name && !showNames) || copiedIcon === name}>
              {copiedIcon === name ? 'Copied!' : name}
            </Tooltip>
            {showNames && <IconName>{name}</IconName>}
          </IconWrapper>
        </button>
      ))}
    </IconGrid>
  </>
);

export const IconsStoryBoard = () => {
  const [showNames, setShowNames] = useState(false);
  const [copiedIcon, setCopiedIcon] = useState<string | null>(null);
  const [hoveredIcon, setHoveredIcon] = useState<string | null>(null);

  const handleCopy = (name: string) => {
    navigator.clipboard.writeText(name);
    setCopiedIcon(name);
    setTimeout(() => setCopiedIcon(null), 2000);
  };

  return (
    <Container>
      <ToggleButton onClick={() => setShowNames(!showNames)}>{showNames ? 'Hide Names' : 'Show Names'}</ToggleButton>

      <IconSection
        title='All Icons'
        iconSet={Icons}
        showNames={showNames}
        onCopy={handleCopy}
        hoveredIcon={hoveredIcon}
        setHoveredIcon={setHoveredIcon}
        copiedIcon={copiedIcon}
      />
    </Container>
  );
};
